import type { ComponentType } from 'react'
import type { ListedVisit } from '../hooks/multiWindow/useNavigationHistory'
import type { PageHistoryItem } from '../components/layout/Titlebar/TitlebarContext'

export interface PageHistoryLabelContext {
  /** Aktuelle Projektnamen nach id. */
  projectNames: ReadonlyMap<string, string>
  /** Das Icon zu einem gespeicherten Icon-Namen (wie im Tab). */
  iconFor: (iconName: string | undefined) => ComponentType<{ size?: number }> | undefined
  /** Name eines Lebensbereichs („Arbeit“). */
  lifeSpaceLabel: (lifeSpace: string) => string
  /** Name für ein Projekt ohne Namen („Neues Projekt“). */
  untitledProject: string
}

/**
 * Die Einträge der Liste am Pfeil (#225). **Projekte mit ihrem aktuellen Namen**: Wer ein frisches
 * Projekt besuchte, bevor es benannt war, sah sonst einen leeren Eintrag (gemeldet 04.10.2026); ein
 * umbenanntes stand unter altem Namen da.
 */
export function labelPageHistory(list: readonly ListedVisit[], ctx: PageHistoryLabelContext): PageHistoryItem[] {
  return list.map(({ index, visit }) => {
    const projectId = visit.path.match(/\/project\/([^/?#]+)/)?.[1]
    const title = projectId
      ? ctx.projectNames.get(projectId) || ctx.untitledProject
      : visit.title || visit.path
    return {
      index,
      title,
      lifeSpaceLabel: ctx.lifeSpaceLabel(visit.lifeSpace),
      icon: ctx.iconFor(visit.iconName),
      ...(projectId ? { projectId } : {}),
    }
  })
}
